import { http } from "./http";

const TENANT_ROUTE_NAME = "tenants";

const Services = {
	// TENANTS API
	getMyConfig: async () => {
		return http.get(`/${TENANT_ROUTE_NAME}/myConfig`);
	},
	getAllTenants: async () => {
		return http.get(`/${TENANT_ROUTE_NAME}/getAllTenants`);
	},
	getTenantConfig: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantConfig/${tenantName}`);
	},
	getTenantPermissions: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantPermissions/${tenantName}`);
	},
	updateTenantPermissions: async ({ tenantName, permissions }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateTenantPermissions`, { permissions, tenantName });
	},
	getTenantCensusReportColumns: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantCensusReportColumns/${tenantName}`);
	},
	updateTenantCensusReportColumns: async ({ tenantName, censusReportColumns }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateTenantCensusReportColumns`, { censusReportColumns, tenantName });
	},
	getTenantClientReportColumns: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantClientReportColumns/${tenantName}`);
	},
	updateTenantClientReportColumns: async ({ tenantName, clientReportColumns }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateTenantClientReportColumns`, { clientReportColumns, tenantName });
	},
	createTenantSection: async ({ tenantName, section }) => {
		return http.post(`/${TENANT_ROUTE_NAME}/createTenantSection`, { section, tenantName });
	},
	getTenantSections: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantSections/${tenantName}`);
	},
	updateTenantSection: async ({ tenantName, section }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateTenantSection`, { section, tenantName });
	},
	deleteTenantSection: async ({ tenantName, sectionId }) => {
		return http.delete(`/${TENANT_ROUTE_NAME}/deleteTenantSection/${sectionId}/${tenantName}`);
	},
	addFilter: async ({ tenantName, filter, sectionId }) => {
		return http.post(`/${TENANT_ROUTE_NAME}/addFilter`, { filter, tenantName, sectionId });
	},
	deleteFilter: async ({ tenantName, filterId }) => {
		return http.delete(`/${TENANT_ROUTE_NAME}/deleteFilter/${filterId}/${tenantName}`);
	},
	updateFilter: async ({ tenantName, filter }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateFilter`, { filter, tenantName });
	},
	getTenantCensusShopCardData: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantCensusShopCardData/${tenantName}`);
	},
	updateTenantCensusShopCardData: async ({ tenantName, censusShopCardData }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateTenantCensusShopCardData`, { censusShopCardData, tenantName });
	},
	getTenantClientShopCardData: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantClientShopCardData/${tenantName}`);
	},
	updateTenantClientShopCardData: async ({ tenantName, clientShopCardData }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateTenantClientShopCardData`, { clientShopCardData, tenantName });
	},
	getTenantSecDifination: async ({ tenantName }) => {
		return http.get(`/${TENANT_ROUTE_NAME}/getTenantSecDifination/${tenantName}`);
	},
	updateTenantSecDifination: async ({ tenantName, secDifination }) => {
		return http.put(`/${TENANT_ROUTE_NAME}/updateTenantsecDifination`, { secDifination, tenantName });
	},
	getMyFilters: async () => {
		return http.get(`/${TENANT_ROUTE_NAME}/getMyFilters`);
	}
};

export default Services;
